/**
 * GrowthChart Organism
 *
 * Gráfico de crescimento
 */
import React from 'react'
import {
	LineChart,
	Line,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	ResponsiveContainer,
	Legend,
} from 'recharts'
import Card from '../atoms/Card'

export default function GrowthChart({
	data,
	title = 'Crescimento',
	lines = [
		{ key: 'users', name: 'Usuários', color: '#10B981' },
		{ key: 'clubs', name: 'Clubes', color: '#3B82F6' },
		{ key: 'matches', name: 'Partidas', color: '#8B5CF6' },
	],
	className = '',
}) {
	if (!data || data.length === 0) {
		return (
			<Card title={title} className={className}>
				<div className="h-64 flex items-center justify-center text-text-body">
					Sem dados disponíveis
				</div>
			</Card>
		)
	}

	return (
		<Card title={title} className={className}>
			<div className="h-80">
				<ResponsiveContainer width="100%" height="100%">
					<LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
						<CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
						<XAxis
							dataKey="date"
							tick={{ fontSize: 12 }}
							stroke="#94A3B8"
						/>
						<YAxis
							tick={{ fontSize: 12 }}
							stroke="#94A3B8"
						/>
						<Tooltip
							contentStyle={{
								backgroundColor: '#1E293B',
								border: 'none',
								borderRadius: '8px',
								color: '#F1F5F9',
							}}
						/>
						<Legend />
						{lines.map((line) => (
							<Line
								key={line.key}
								type="monotone"
								dataKey={line.key}
								name={line.name}
								stroke={line.color}
								strokeWidth={2}
								dot={false}
								activeDot={{ r: 6 }}
							/>
						))}
					</LineChart>
				</ResponsiveContainer>
			</div>
		</Card>
	)
}
